var map = {
	"./1/symbol_0.png": 37444,
	"./1/symbol_1.png": 91341,
	"./1/symbol_10.png": 15673,
	"./1/symbol_11.png": 35120,
	"./1/symbol_12.png": 88619,
	"./1/symbol_13_x10.png": 48540,
	"./1/symbol_13_x100.png": 76198,
	"./1/symbol_13_x1000.png": 52180,
	"./1/symbol_13_x12.png": 72974,
	"./1/symbol_13_x15.png": 71457,
	"./1/symbol_13_x2.png": 2709,
	"./1/symbol_13_x20.png": 62609,
	"./1/symbol_13_x25.png": 19852,
	"./1/symbol_13_x3.png": 91084,
	"./1/symbol_13_x4.png": 40483,
	"./1/symbol_13_x5.png": 50650,
	"./1/symbol_13_x50.png": 22752,
	"./1/symbol_13_x6.png": 26897,
	"./1/symbol_13_x8.png": 25567,
	"./1/symbol_2.png": 61014,
	"./1/symbol_3.png": 74303,
	"./1/symbol_4.png": 22976,
	"./1/symbol_5.png": 1097,
	"./1/symbol_6.png": 86482,
	"./1/symbol_7.png": 23688,
	"./1/symbol_8.png": 5068,
	"./1/symbol_9.png": 57333,
	"./2/symbol_0.png": 67505,
	"./2/symbol_1.png": 69640,
	"./2/symbol_10.png": 71418,
	"./2/symbol_11.png": 92995,
	"./2/symbol_12.png": 56136,
	"./2/symbol_2.png": 54915,
	"./2/symbol_3.png": 14957,
	"./2/symbol_4.png": 93845,
	"./2/symbol_5.png": 24748,
	"./2/symbol_6.png": 44807,
	"./2/symbol_7.png": 26494,
	"./2/symbol_8.png": 55401,
	"./2/symbol_9.png": 576,
	"./3/symbol_0.png": 10094,
	"./3/symbol_1.png": 93239,
	"./3/symbol_10.png": 3703,
	"./3/symbol_12.png": 32485,
	"./3/symbol_2.png": 85660,
	"./3/symbol_3.png": 21573,
	"./3/symbol_4.png": 51146,
	"./3/symbol_5.png": 83059,
	"./3/symbol_6.png": 87448,
	"./3/symbol_7.png": 8577,
	"./3/symbol_8.png": 80710,
	"./3/symbol_9.png": 62255,
	"./4/symbol_0.png": 48699,
	"./4/symbol_1.png": 33874,
	"./4/symbol_10.png": 82984,
	"./4/symbol_12.png": 55130,
	"./4/symbol_2.png": 64841,
	"./4/symbol_3.png": 70368,
	"./4/symbol_4.png": 21695,
	"./4/symbol_5.png": 24758,
	"./4/symbol_6.png": 38733,
	"./4/symbol_7.png": 84836,
	"./4/symbol_8.png": 28707,
	"./4/symbol_9.png": 80954,
	"./gold1.png": 4586,
	"./gold2.png": 53569,
	"./gold3.png": 80856,
	"./gold4.png": 60471,
	"./silver1.png": 7861,
	"./silver2.png": 87486,
	"./silver3.png": 63271,
	"./silver4.png": 83656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29033;